/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TableContent/view.blocks to change it.
import React from 'react'
import TableX from 'DesignSystem/TableX/react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TableContent({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/TableContent",
  value,
  onSortChange
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TableContent.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TableContent.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TableContent.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={value}
 onSortChange={onSortChange}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}